import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const ReactQuillWrapper = ({ quillContent, onChange, textareaRef,setCursorPos }) => {
  const [text, setText] = useState(quillContent ?? "");
  const [displayContent, setDisplayContent] = useState(quillContent ?? "");

useEffect(()=>{
  quillContent&&setText(quillContent)
},[quillContent])

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ color: [] }, { background: [] }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
  ];

  const handleChange = (value) => {
    setText(value);
    if (onChange) {
      onChange(value);
    }
  };

  useEffect(() => {
    setDisplayContent(text);
  }, [text]);

  return (
    <div className="quill-wrapper">
      <ReactQuill
      onFocus={(e)=>{
        setCursorPos(textareaRef.current?.selection?.index)
console.log(textareaRef.current,"____________");
      }}
        ref={textareaRef}
        value={text}
        modules={modules}
        formats={formats}
        onChange={handleChange}
      />
    </div>
  );
};

export default ReactQuillWrapper;
